import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll flex flex-col space-y-3 py-2 px-3"
};
const _hoisted_3 = { class: "text-md font-medium text-gray-700 px-3" };
const _hoisted_4 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_5 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_6 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_7 = { class: "w-40 flex items-center" };
const _hoisted_8 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_9 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_10 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_11 = { class: "w-40 flex items-center" };
const _hoisted_12 = { class: "text-md font-medium text-gray-700 px-3 pt-3" };
const _hoisted_13 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_14 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_15 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_16 = { class: "w-40 flex items-center" };
const _hoisted_17 = { class: "text-md font-medium text-gray-700 px-3 pt-3" };
const _hoisted_18 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_19 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_20 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_21 = { class: "w-40 flex items-center" };
import { Tools } from '@/types/tools';
import { UIDivider, UIInputNumber, UISlider } from '@gohighlevel/ghl-ui';
import Konva from 'konva';
import { computed, inject, onMounted, onUnmounted, ref, watch, } from 'vue';
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import EmitterEvent from '@/events';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdjustmentsTool',
    props: {
        baseImage: {
            type: Object,
            require: true,
        },
        reset: {
            type: Boolean,
            require: true,
        },
        sectionReset: {
            type: Boolean,
            require: true,
        },
        selectedOption: {
            type: String,
            require: true,
        },
    },
    emits: ['change'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        const brightness = ref(0);
        const contrast = ref(0);
        const shadows = ref(0);
        const saturation = ref(0);
        const temperature = ref(0);
        const clarity = ref(0);
        const blur = ref(0);
        const changed = ref(false);
        const beforeFilter = ref({});
        const afterFilter = ref({});
        const isReset = computed(() => props.reset);
        const isSectionReset = computed(() => props.sectionReset);
        onMounted(() => {
            emitter.on(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, setDefaultValues);
        });
        onUnmounted(() => {
            emitter.off(EmitterEvent.IMAGE_EDITOR_HISTORY_SET);
        });
        watch(isReset, () => {
            if (!isReset.value)
                return;
            resetValues();
        });
        watch(isSectionReset, () => {
            if (!isSectionReset.value || props.selectedOption !== Tools.ADJUSTMENTS)
                return;
            resetFilters();
        });
        function addFilter(filterName) {
            let filters = props.baseImage.filters();
            if (!(filters === null || filters === void 0 ? void 0 : filters.length))
                filters = [];
            const isExists = filters.find(f => f.name === filterName);
            if (!isExists) {
                filters.push(Konva.Filters[filterName]);
                props.baseImage.filters(filters);
            }
            changed.value = true;
            emits('change');
        }
        function resetFilters() {
            if (!changed.value)
                return;
            let filters = props.baseImage.filters();
            if (filters === null || filters === void 0 ? void 0 : filters.length) {
                filters = filters.filter(f => f.name.includes('customFilter'));
                props.baseImage.filters(filters);
            }
            resetValues();
        }
        function resetValues() {
            brightness.value = 0;
            contrast.value = 0;
            shadows.value = 0;
            saturation.value = 0;
            temperature.value = 0;
            clarity.value = 0;
            blur.value = 0;
            changed.value = false;
        }
        function setHistory() {
            const id = props.baseImage.id();
            historyStore.setHistory(id, Tools.ADJUSTMENTS, beforeFilter.value, afterFilter.value, HistoryType.UPDATE);
        }
        function setDefaultValues(history) {
            if (history && history.source === Tools.ADJUSTMENTS) {
                history.filterValues.forEach((val) => {
                    switch (val.name) {
                        case 'brightness':
                            brightness.value = Math.round(val.value * 100);
                            break;
                        case 'saturation':
                            saturation.value = Math.round(val.value * 100);
                            break;
                        case 'contrast':
                            contrast.value = val.value;
                            break;
                        case 'blur':
                            blur.value = Math.round((val.value / 40) * 100);
                            break;
                    }
                });
                const filters = props.baseImage.filters();
                const filtersNames = filters.map(f => !f.name.includes('customFilter') && f.name);
                const availableFilters = ['Brighten', 'Contrast', 'HSL', 'Blur'].filter(f => !filtersNames.includes(f));
                availableFilters.forEach(f => {
                    switch (f) {
                        case 'Brighten':
                            brightness.value = 0;
                            break;
                        case 'Contrast':
                            contrast.value = 0;
                            break;
                        case 'HSL':
                            saturation.value = 0;
                            break;
                        case 'Blur':
                            blur.value = 0;
                    }
                });
            }
        }
        function brightnessChange() {
            if (isNaN(brightness.value))
                return;
            beforeFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            addFilter('Brighten');
            props.baseImage.brightness(brightness.value / 100);
            afterFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        function contrastChange() {
            if (isNaN(contrast.value))
                return;
            beforeFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            addFilter('Contrast');
            props.baseImage.contrast(contrast.value);
            afterFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        function saturationChange() {
            if (isNaN(saturation.value))
                return;
            beforeFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            addFilter('HSL');
            props.baseImage.saturation(saturation.value / 100);
            afterFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        function blurChange() {
            if (isNaN(blur.value))
                return;
            beforeFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            addFilter('Blur');
            props.baseImage.blurRadius(40 * (blur.value / 100));
            afterFilter.value = getHistoryObject(Tools.ADJUSTMENTS, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('adjustments.title')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('adjustments.light.title')), 1 /* TEXT */),
                    _createVNode(_unref(UIDivider)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('adjustments.light.brightness')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(UIInputNumber), {
                                id: "media-editor-adjustments-brightness-input",
                                size: "medium",
                                value: brightness.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((brightness).value = $event)),
                                style: { "width": "58px" },
                                min: -100,
                                max: 100,
                                showButton: false,
                                placeholder: "",
                                onBlur: brightnessChange
                            }, null, 8 /* PROPS */, ["value"]),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(UISlider), {
                                    value: brightness.value,
                                    "onUpdate:value": [
                                        _cache[1] || (_cache[1] = ($event) => ((brightness).value = $event)),
                                        brightnessChange
                                    ],
                                    step: 1,
                                    tooltip: false,
                                    min: -100,
                                    max: 100
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('adjustments.light.contrast')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(UIInputNumber), {
                                id: "media-editor-adjustments-contrast-input",
                                size: "medium",
                                value: contrast.value,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((contrast).value = $event)),
                                style: { "width": "58px" },
                                min: -100,
                                max: 100,
                                showButton: false,
                                placeholder: "",
                                onBlur: contrastChange
                            }, null, 8 /* PROPS */, ["value"]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(UISlider), {
                                    value: contrast.value,
                                    "onUpdate:value": [
                                        _cache[3] || (_cache[3] = ($event) => ((contrast).value = $event)),
                                        contrastChange
                                    ],
                                    step: 1,
                                    tooltip: false,
                                    min: -100,
                                    max: 100
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ])
                    ]),
                    _createCommentVNode(" <div class=\"flex flex-col justify-start space-y-2 px-3 py-2\">\n          <span class=\"text-xs font-medium text-gray-700\">{{\n            $t('adjustments.light.shadows')\n          }}</span>\n          <div class=\"flex flex-row items-center space-x-2\">\n            <UIInput\n              id=\"media-editor-adjustment-shadows-input\"\n              size=\"medium\"\n              v-model:value=\"shadowsText\"\n              style=\"width: 58px\"\n              @update:model-value=\"updateInput('shadows', shadowsText)\"\n              placeholder=\"\"\n            />\n            <div class=\"w-40 flex items-center\">\n              <UISlider\n                v-model:value=\"shadows\"\n                :step=\"1\"\n                :tooltip=\"false\"\n                :min=\"0\"\n                :max=\"100\"\n              />\n            </div>\n          </div>\n        </div> "),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('adjustments.color.title')), 1 /* TEXT */),
                    _createVNode(_unref(UIDivider)),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('adjustments.color.saturation')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_15, [
                            _createVNode(_unref(UIInputNumber), {
                                id: "media-editor-adjustment-saturation-input",
                                size: "medium",
                                value: saturation.value,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event) => ((saturation).value = $event)),
                                style: { "width": "58px" },
                                min: -100,
                                max: 100,
                                showButton: false,
                                placeholder: "",
                                onBlur: saturationChange
                            }, null, 8 /* PROPS */, ["value"]),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(UISlider), {
                                    value: saturation.value,
                                    "onUpdate:value": [
                                        _cache[5] || (_cache[5] = ($event) => ((saturation).value = $event)),
                                        saturationChange
                                    ],
                                    step: 1,
                                    tooltip: false,
                                    min: -100,
                                    max: 100
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ])
                    ]),
                    _createCommentVNode(" <div class=\"flex flex-col justify-start space-y-2 px-3 py-2\">\n          <span class=\"text-xs font-medium text-gray-700\">{{\n            $t('adjustments.color.temperature')\n          }}</span>\n          <div class=\"flex flex-row items-center space-x-2\">\n            <UIInputNumber\n              id=\"media-editor-adjustment-temperature-input\"\n              size=\"medium\"\n              v-model:value=\"temperatureText\"\n              :min=\"-100\"\n              :max=\"100\"\n              style=\"width: 58px\"\n              :showButton=\"false\"\n              @update:model-value=\"updateInput('temperature', temperatureText)\"\n              placeholder=\"\"\n            />\n            <div class=\"w-40 flex items-center\">\n              <UISlider\n                v-model:value=\"temperature\"\n                :step=\"0.003921\"\n                :tooltip=\"false\"\n                :min=\"-1\"\n                :max=\"1\"\n              />\n            </div>\n          </div>\n        </div> "),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('adjustments.detail.title')), 1 /* TEXT */),
                    _createVNode(_unref(UIDivider)),
                    _createCommentVNode(" <div class=\"flex flex-col justify-start space-y-2 px-3 py-2\">\n          <span class=\"text-xs font-medium text-gray-700\">{{\n            $t('adjustments.detail.clarity')\n          }}</span>\n          <div class=\"flex flex-row items-center space-x-2\">\n            <UIInput\n              id=\"media-editor-adjustment-clarity-input\"\n              size=\"medium\"\n              v-model:value=\"clarityText\"\n              style=\"width: 58px\"\n              @update:model-value=\"updateInput('clarity', clarityText)\"\n              placeholder=\"\"\n            />\n            <div class=\"w-40 flex items-center\">\n              <UISlider\n                v-model:value=\"clarity\"\n                :step=\"1\"\n                :tooltip=\"false\"\n                :min=\"2\"\n                :max=\"20\"\n              />\n            </div>\n          </div>\n        </div> "),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('adjustments.detail.blur')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_20, [
                            _createVNode(_unref(UIInputNumber), {
                                id: "media-editor-adjustment-blur-input",
                                size: "medium",
                                value: blur.value,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event) => ((blur).value = $event)),
                                min: 0,
                                max: 100,
                                style: { "width": "58px" },
                                showButton: false,
                                placeholder: "",
                                onBlur: blurChange
                            }, null, 8 /* PROPS */, ["value"]),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_unref(UISlider), {
                                    value: blur.value,
                                    "onUpdate:value": [
                                        _cache[7] || (_cache[7] = ($event) => ((blur).value = $event)),
                                        blurChange
                                    ],
                                    step: 1,
                                    tooltip: false,
                                    min: 0,
                                    max: 100
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
